import axios from "axios";

export const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// -------------------------------------------------------------------------
// GLOBAL axios interceptor — attach the current user's Bearer token on
// EVERY axios call (both the configured `api` instance above AND any raw
// `axios.get(...)` sprinkled through the codebase). This is critical for
// correctness:
//
//   Many legacy pages (e.g. AccountsPaymentDesk) use raw `axios` which
//   does NOT have the per-instance interceptor. Without this global one,
//   those requests would only carry browser cookies for same-origin
//   routes. If a stale `access_token` cookie survives a session switch
//   (shared tabs, incomplete logout, cross-session browser state), the
//   backend will authenticate the request as the WRONG user — resulting
//   in misattributed chat senders, misattributed audit rows, etc.
//
//   The backend's `get_current_user` already prefers Bearer over cookie,
//   so once we always attach Bearer, the current session always wins —
//   no matter what cookie happens to be in the jar.
// -------------------------------------------------------------------------
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers = config.headers || {};
    if (!config.headers.Authorization) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function formatCurrency(n) {
  const v = Number(n || 0);
  return new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(v);
}

export function formatDate(iso) {
  if (!iso) return "-";
  try {
    return new Date(iso).toLocaleDateString("en-IN", { year: "numeric", month: "short", day: "numeric" });
  } catch { return iso; }
}
